import React from "react";
import { Helmet } from "react-helmet";
import { Default } from "../layouts/default";
import "../../css/HowItWorks.css";
import { Link } from "react-router-dom";

const HowItWorks = () => {
  return (
    <>
      <Helmet>
        <title>How to Book a Sports Venue Online | BookVenue India</title>
        <meta
          name="description"
          content="Learn how to book sports venues online with BookVenue. Follow simple steps to book cricket grounds, turfs, and courts "
        />
      </Helmet>
      <Default>
        <section className="how-it-works-section py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center mb-5">
                  <h1 className="how-title">How It Works </h1>
                  <p className="how-subtitle">
                    BookVenue makes it simple to book sports venues online
                    across India.
                  </p>
                </div>

                <div className="how-card mb-5">
                  <h2>For Users</h2>

                  <div className="step-box">
                    <h4>Step 1: Sign Up</h4>
                    <p>Create your account on the platform.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 2: Select Venue</h4>
                    <p>Choose your preferred sports venue.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 3: Select Date and Time</h4>
                    <p>Pick your desired slot.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 4: Click on Book Now</h4>
                    <p>Proceed to the booking and payment page.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 5: Make Payment</h4>
                    <p>Complete the payment securely.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 6: Booking Confirmation</h4>
                    <p>After successful payment:</p>
                    <ul className="steps">
                      <li>Your booking will be confirmed</li>
                      <li>You will receive confirmation via email and SMS</li>
                    </ul>
                  </div>

                  <div className="step-box">
                    <h4>Step 7: Dashboard Access</h4>
                    <p>From your dashboard, you can:</p>
                    <ul className="steps">
                      <li>View all bookings</li>
                      <li>Check upcoming bookings</li>
                      <li>View payment history</li>
                      <li>
                        Edit profile details like name, phone, email, and
                        address
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="how-card mb-5">
                  <h2>For Vendors</h2>

                  <div className="step-box">
                    <h4>Step 1: Click on “List Your Court”</h4>
                    <p>Available on the homepage top-right.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 2: Sign Up</h4>
                    <p>Register as a vendor.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 3: Add Venue Details</h4>
                    <p>
                      Fill all required details such as court info, pricing, and
                      facilities.
                    </p>
                  </div>

                  <div className="step-box">
                    <h4>Step 4: Submit Request</h4>
                    <p>Submit your venue for approval.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 5: Admin Approval</h4>
                    <p>Your venue will go live only after admin approval.</p>
                  </div>

                  <div className="step-box">
                    <h4>Step 6: Manage Your Venue</h4>
                    <p>
                      Once approved, manage your venue, update details, and
                      handle bookings.
                    </p>
                  </div>
                </div>

                <div className="how-card">
                  <h2>Support</h2>
                  <p>
                    For any queries, email:{" "}
                    <Link to="mailto:admin@bookvenue.app">
                      admin@bookvenue.app
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Default>
    </>
  );
};

export default HowItWorks;
